import { render } from "./DetailCategoriesSelectorComponent.vue?vue&type=template&id=c12a0cec&scoped=true"
import script from "./DetailCategoriesSelectorComponent.vue?vue&type=script&lang=js"
export * from "./DetailCategoriesSelectorComponent.vue?vue&type=script&lang=js"

import "./DetailCategoriesSelectorComponent.vue?vue&type=style&index=0&id=c12a0cec&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c12a0cec"]])

export default __exports__